

(function(){

	// Library depencencies
	var Application = include('springroll.Application'),
	
		TitleState = include('WGBH.TitleState'),
		IntroState = include('WGBH.IntroState'),
		IndexState = include('WGBH.IndexState'),
		GameState = include('WGBH.GameState'),
		Sound = include('springroll.Sound'),
		Debug = include('springroll.Debug',false),

		Display = include('springroll.pixi.PixiDisplay'),
		Text = include('WGBH.PIXIText');

	var transitionReady=function(img,asset) {
		images[asset.id]=new PIXI.Texture.fromImage(imageurls[asset.id]);
	};

	var preloadforapp=[
		{"id":"RuffTransition_atlas_","src":"assets/images/RuffTransition_atlas_.png", "complete":transitionReady}
	];

	var alpconfigs={
		"dev":{
			"apikey":"gHheaNj-htihQQztM5OZipoiNxUqHwfsi",
			"gameuri":"/game/pbskids/ruff_ple/penguin",
			"nooidc":true,
			"dev":true,
			"createlearner":true
		},
		"privo":{
			"apikey":"gLT3kMNM8BmTDrdVpWGD3N12VzAZPO6C",
			"gameuri":"/game/pbskids/ruff_ple/fish_force",
			"nooidc":false,
			"dev":true
		},
		"prod": {
            "apikey":"gdBII5L1JygIgwTnuHzQgVrwwnjIQDbmM",
            "gameuri":"/game/pbskids/ruff_ple/fish_force",
            "nooidc":false,
            "dev":false
		}
	};
	
	
	var alpsettings=alpconfigs.prod;


	JSON3.noConflict(); // force native JSON.stringify and JSON.parse

	// Create a new application
	var app = new Application({
		name: "Penguin",
		canvasId: "stage",
		state: 'title',
		display: Display,
		configPath: 'assets/config/config.json',
		captionsPath: 'assets/config/captions.json',
		preload:preloadforapp,
		displayOptions:	{
			clearView: true,
		},
		alp: {
            apiKey:alpsettings.apikey, // privo:gLT3kMNM8BmTDrdVpWGD3N12VzAZPO6C
            gameUri:alpsettings.gameuri, // privo: /game/pbskids/ruff_ple/fish_force
            options: {dev:alpsettings.dev,noOidc:alpsettings.nooidc}, // privo: noOidc:false
    //        defaultHttpCache:localalp,
            version:{
                version:"1.0.0",
                build:"0"
            },
            recLocalDimension:"/local_dimension/pbskids/ruff_ple/forces_and_motion_ff",
	        promptPrefix:"/prompt/pbskids/ruff_ple/fish_force/",
	        eventOverride:SpringrollAlpPluginPenguinHelper.eventOverride,
	        recCallback:SpringrollAlpPluginPenguinHelper.recCallback,
	        recParams:SpringrollAlpPluginPenguinHelper.recParams
        }
	});

	// Handle when app is ready to use
	app.on('init', function()
	{
	// hide the loading image (on the page) and show the canvas, now that app is ready.
	$(".loading").hide();
	
    	this.animator.captions.mute=true;
	
		this.gameid=this.config.gameoptions.gameid;
	
		var assets = this.config.assets;		
		var scaleconfig = this.config.scaling;
		
		this.usersavestate={'introList':{},'levelHistory':[],'cancreate':false,'createdLevels':[]};
		
		var statetest={
			"introLevelsCompleted":{
			},
			"levelCompleteHistory":[]
		};
		SpringrollAlpPluginPenguinHelper.init.call(this);
		app.alpPlugin.setState(statetest);
		
		if(alpsettings.createlearner) {
  			var email = Date.now() + '@yopmail.com';
			var password="badpassword";
			this.alpPlugin.sdk.createUser({email:email, password:password});
			this.alpPlugin.sdk.createLearner({name:'L'}).then(function() {
				// LEARNER CREATED
			});
		}
		
			this.states = {
			title: new TitleState({
				next: 'intro',
				preload: assets.title.concat(assets.universal),
				scaling: scaleconfig.title
			}),
			intro: new IntroState({
				next:'game',
				preload: assets.intro.concat(assets.universal),
				scaling: scaleconfig.intro
			}),
			index: new IndexState({
				next:'game',
				preload: assets.index,
				scaling: scaleconfig.index
			}),
			game: new GameState({
				preload: assets.game.concat(assets.universal),
				next:'intro',
				scaling: scaleconfig.game
			})
			
			};		
			
			this.taptype='mousedown';
			this.dragtype='mousemove';
			this.releasetype='mouseup';
			this.outtype='mouseout';
			this.pointer='mouse';
			this.hovertype="mouseover";
			this.hoverout="mouseout";
			if ('ontouchstart' in document.documentElement) {
				this.taptype='touchstart';
				this.dragtype='touchmove';
				this.outtype='touchleave';
				this.releasetype='touchend';
				this.pointer='touch';
				this.hovertype=null;
			}

	this.click='click';

	this.captions.textField = document.getElementById("captions");
	
	// TODO: override learning object?


	// Need to do my own transition stuff because of half-baked PIXI support
	/* labels are
		hidden,
		onTransitionOut,
		onTransitionOut_stop,
		onTransitionIn,
		onTransitionIn_stop
	*/

	this.pixitrans=new WGBH.PixiClip(app.config.PixiWheel);
	
	this.pixitrans._clips.bar.update=function() { // spin the bar programmatically
		this.rotation+=0.1047197551;
	};

	this.pixitrans.center=app.config.scalingSize.width/2;
	var whitesquare=new PIXI.Graphics();
	whitesquare.beginFill(UIPanel.colorfromhex('#ffffff'), 1);
	whitesquare.drawRect(
            0,
            0,
            app.config.scalingSize.maxWidth,
            app.config.scalingSize.maxHeight
          );
    whitesquare.position.x=app.config.scalingSize.maxWidth/-2;
    this.pixitrans.bg=new PIXI.Container();
    this.pixitrans.bg.position.x=this.pixitrans.center;
    this.pixitrans.addChildAt(this.pixitrans.bg,0);
    this.pixitrans.container.position.x=this.pixitrans.center;
	this.pixitrans.bg.addChild(whitesquare);
	this.pixitrans.loading=Text.maketextobject(app.config.PixiWheel.text.text,app.config.PixiWheel.text.style);
	this.pixitrans.loading.position=new PIXI.Point(app.config.PixiWheel.text.p.x,app.config.PixiWheel.text.p.y);
	this.pixitrans.loading.visible=false;
	this.pixitrans.bg.addChild(this.pixitrans.loading);
	this.transition=this.pixitrans;

	this.manager.on("onTransitionIn",function() {
		app.pixitrans.loading.visible=false;
		createjs.Tween.get(app.transition.container.position).to({x:app.config.scalingSize.maxWidth+app.pixitrans.center,y:0},1000);
	});
	
	this.manager.on("onTransitionOut",function() {
		app.pixitrans.loading.visible=true;
		app.transition.container.position={x:app.pixitrans.center-app.config.scalingSize.maxWidth,y:0};
		createjs.Tween.get(app.transition.container.position).to({x:app.pixitrans.center,y:0},1000);
	});
	
	
	this.loaduserdata();


	// OPENID...saving this in case we need to react
	
			app.container.on('openIdAuthSuccess', function(event) {
			});

			app.container.on('openIdAuthFailure', function(event) {
			});

			app.container.on('openIdRefreshAuthSuccess', function(event) {
				if(event.data.name==="Kidaptive ALP") {
					app.alpPlugin.sdk.refresh();
					app.loaduserdata();
				}
			});

			app.container.on('openIdRefreshAuthFailure', function(event) {
			});

			app.container.on('openIdRefreshAuthFinished', function(event) {
			});

			app.container.on('openIdProviderFailure', function(event) {
			});

			app.container.on('openIdRefreshProviderFailure', function(event) {
			});

			app.container.on('openIdAuthFinished', function(event) {
				app.container.send('g_requestOpenIdRefreshAuth');
			});

		app.container.send('g_requestOpenIdRefreshAuth');
	});
	
	app.roundid=""; // always need to pass something for kidaptive ID

	/* SAVE/LOAD */

	app.container.on('loadeduserdata',function(ev) {
		if(ev.data) {
			app.usersavestate=ev.data;
			// update the kidaptive helper			
			app.updatekidaptivestate();
		}
	});
	
	
	app.saveuserdata=function() {
		// pass to the container
		this.container.send("savestate",this.usersavestate);
		// also save locally
		this.savejson("state",this.usersavestate);
	};
	
	app.loaduserdata=function(callback) {
		var alreadysaved=this.loadjson("state");
		if(!alreadysaved) {
			this.savejson("state",this.usersavestate);
		} else {
			this.usersavestate=alreadysaved;					
			app.updatekidaptivestate(); // start with what's in local storage
		}
		this.container.send("loadstate");
	};
	
	app.savejson=function(key,json) {
		springroll.SavedData.write(app.config.gameoptions.gameid+key,
		JSON.stringify(json));
		// TODO: also write to the DB, if user is logged in.
	};
	
	app.loadjson=function(key) {
		return JSON.parse(springroll.SavedData.read(app.config.gameoptions.gameid+key));
		// TODO: load from DB, if user is logged in.
	};

	app.updatekidaptivestate=function() {
		app.alpPlugin.setState({"introLevelsCompleted":this.usersavestate.introList,"levelCompleteHistory":this.usersavestate.levelHistory});
	};
	

/* TRACKING FUNCTIONS */
	
	app.trackevent=function(eventname,eventparams) {
		/* some common items for different events:	
			- game time: ms count since game start - all events) : automatically recorded by LAP
			- round: current round (or 0 if not in a round) : this is automatically incremented by LAP
			- level: current level (or 0 if no level) : this is automatically incremented by LAP
			- event_count: count of how many events have been fired in this session? Automatically incremented by LAP

			- kid: the kidaptive URI for the level (i.e., the identity of the level itself): DO send this (first every time?)!

		*/
		if(!app.config.gameoptions.trackevents[eventname]) {return;} // not tracking some, waiting for fix to back end
			
//		Handy place to check LAP: 
//Debug.log("LAP " + eventname,this.learning[eventname],eventparams);
		var paramlist=[];
		for(var id in eventparams.idorder) {
			paramlist.push(eventparams[eventparams.idorder[id]]);
		}
		this.learning[eventname].apply(this.learning,paramlist);
		
	};
	
	
	// 4070
	app.trackstrayclick=function(coords) {
		this.trackevent('offClick',{
			"idorder":["coordinates","kid"],
			"kid":this.roundid,
			"coordinates":{x:parseInt(coords.x),y:parseInt(coords.y),stage_width:app.display.width,stage_height:app.display.height},
		});
	};
	
	// 4080
	app.trackdwelltime=function(time,objectid) {
		this.trackevent('dwellTime',{
				"idorder":["dwell_time","object","kid"],
				"kid":this.roundid,
				"dwell_time":time,
				"object":objectid
		});
	};
	
	// 4010
	app.trackclickplay=function(coords) {
	    var passdata={"coordinates":coords,"kidaptive_uri":this.roundid};
		this.trackevent('clickPlay',{
				"idorder":["custom"],
				"kid":this.roundid,
				"coordinates":coords,
				"custom":passdata
		});
	};
	
	app.getmovieinfo=function(movieid) {
		// look up duration and description info for a movie
		return this.config.movies[movieid];
	};
	
	// these are the tracking events that live outside the game state
	// 2080
	app.trackmoviestart=function(movieid) {
		var info=this.getmovieinfo(movieid);
		this.trackevent('startMovie',{
				"idorder":["collection"],
				"kid":this.roundid,
				"movie_id":movieid,
				"duration":info.duration,
				"description":info.description,
				"collection":{"movie_id":movieid,"duration":info.duration,"description":info.description,"kidaptive_uri":this.roundid}
		});
	};
	
	// 2083
	app.trackmovieend=function(movieid) {
		var info=this.getmovieinfo(movieid);
		this.trackevent('endMovie',{
				"idorder":["collection"],
				"kid":this.roundid,
				"movie_id":movieid,
				"duration":info.duration,
				"description":info.description,
				"collection":{"movie_id":movieid,"duration":info.duration,"description":info.description,"kidaptive_uri":this.roundid}

		});
	};
	
	// 2081
	app.trackmovieskip=function(movieid) {
		var info=this.getmovieinfo(movieid);
		this.trackevent('skipMovie',{
				"idorder":["collection"],
				"kid":this.roundid,
				"movie_id":movieid,
				"duration":info.duration,
				"description":info.description,
				"collection":{"movie_id":movieid,"duration":info.duration,"description":info.description,"kidaptive_uri":this.roundid}
		});
	};
	

	app.startdwelltimer=function(object) {
		app.startdwell=Date.now();
		app.dwellobject=object;
	};
	
	app.stopdwelltimer=function() {
		if(app.startdwell) {
			app.dwelltime=Date.now() - app.startdwell;
			if(app.dwelltime > 1500) {
				app.trackdwelltime(app.dwelltime,app.dwellobject.id);
			}
		}
		app.startdwell=null;
		app.dwelltime=0;
	};
	
	
	// CENTRALIZED AUDIO
	
	app.soundtrack={
		played:{}, // keep track of things that have been played so they don't get played again
		voPlayer:app.voPlayer,
		
		playVO:function(soundname,callback) {
			this.voPlayer.play(soundname,callback);
		},
		
		voloc:function() {
			if(this.voPlayer.duration===0) return 0;
			return this.voPlayer.currentPosition/this.voPlayer.currentDuration; // new in SpringRoll 0.4.24
		},
		
		voplaying:function() {
			return this.voPlayer.currentVO;
		},
		
		stopVO:function() {
			this.voPlayer.stop();
		},
		
		playSFX:function(sfx) {
			this.sfx=app.sound.play(sfx);
		},
		
		bequiet:function() {
			app.sound.stopAll();
		},
		
		playAmbient:function(sound) {
			if(sound===this.ambientsound) return;
			if(this.ambient) {
				this.ambient.stop(this.ambientsound);
				this.ambientsound=null;
				this.ambient=null;
			}
			if(sound) {
				this.ambient=app.sound.play(sound,{'loop':-1});
				this.ambientsound=sound;
			}
		},
		
		stopAmbient:function() {
			this.ambient.stop(this.ambientsound);
		},
		
		playMusic:function(sound) {
			if(sound===this.musicsound) return;
			if(this.music) {
				this.music.stop(this.musicsound);
				this.musicsound=null;
			}
			if(sound) {
				this.music=app.music.play(sound,{'loop':-1});
				this.musicsound=sound;
			}
		}
	};


	// Assign to the window for easy access
	window.app = app;
	
	window.images={};
	window.imageurls={};
	
	document.addEventListener("DOMContentLoaded", function(event) {
    	// TODO: fix for Safari bug with SoundJS - https://github.com/CreateJS/SoundJS/issues/217
    	
    	// setTimeout(function(){createjs.Sound.on("fileload", this.loadHandler, this)},500);
    	
  	});
	
	for(var img in preloadforapp) {
		window.imageurls[preloadforapp[img].id]=preloadforapp[img].src;
	}
}());